const nonLeapYearMonthOffsets = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
const leapYearMonthOffsets = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
/**
 * Returns the numerical representation of the day of the year for a given date.
 * @hidden
 * @param year The year of the date.
 * @param month The month of the date.
 * @param day The day of the date.
 */
export const getDayOfYear = (year, month, day) => {
    const isLeapYear = year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
    const monthOffset = (isLeapYear ? leapYearMonthOffsets : nonLeapYearMonthOffsets)[month - 1];
    return day + monthOffset;
};
//# sourceMappingURL=get-day-of-year.js.map